import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  Paper,
  Tabs,
  Tab,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  RateReview as RateReviewIcon,
} from '@material-ui/icons';

import BaseButton from '../common/BaseButton';
import TabPanel from '../common/TabPanel';
import ReviewSummary from '../common/ReviewSummary';
import ReviewCardList from '../common/ReviewCardList';
import WriteReviewForm from '../forms/WriteReviewForm';
import { selectDisableWriteReview, selectGuest } from '../../store/widgetSlice';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: 750,
    maxWidth: '100%',
  },
  panel: {
    backgroundColor: theme.palette.background.default,
  },
  status: {
    fontWeight: 600,
  },
  details: {
    maxWidth: 260,
    fontSize: 14,
  },
  selfie: {
    width: 150,
    height: 150,
    borderRadius: '50%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  document: {
    maxWidth: 200,
    height: 'auto',
  },
  bold: {
    fontWeight: 600,
  },
  cell: {
    'tr:last-child &': {
      borderBottom: 0,
    },
  },
}));

export default function WriteReviewModal() {
  const classes = useStyles();
  const disableWriteReview = useSelector(selectDisableWriteReview);
  const guest = useSelector(selectGuest);

  const [open, setOpen] = React.useState(false);
  const [currentTab, setCurrentTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <BaseButton
        IconComponent={RateReviewIcon}
        onClick={handleClickOpen}
        fullWidth
        disabled={disableWriteReview}
      >
        Reviews
      </BaseButton>
      <Dialog className={classes.dialog} open={open} onClose={handleClose} maxWidth="sm">
        <Paper>
          <Tabs
            value={currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            variant="fullWidth"
          >
            <Tab label="Verification Status" />
            <Tab label="Reviews" disabled={!guest} />
          </Tabs>
        </Paper>
        <DialogContent>
          <TabPanel value={currentTab} index={0}>
            <Box pb={1}>
              <WriteReviewForm />
            </Box>
          </TabPanel>
          <TabPanel value={currentTab} index={1}>
            <Box pb={1}>
              <Typography className={classes.name} component="h2" bottomGutter>
                {`${guest && guest.firstName} ${guest && guest.lastName}`}
              </Typography>
            </Box>
            <ReviewSummary open={open} />
            <Grid item xs="12">
              <ReviewCardList open={open} />
            </Grid>
          </TabPanel>
        </DialogContent>
      </Dialog>
    </div>
  );
}
